<template>
  <section>
    <form method="post" @submit.prevent="send" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.update') + $t('attributes.country') }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="code" :label="$t('attributes.code')">
              <b-input
                v-model="form.code"
                name="code"
                :placeholder="
                  $t('message.please_input') + $t('attributes.code')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="english_name"
              :label="$t('attributes.english_name')"
            >
              <b-input
                v-model="form.english_name"
                name="english_name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.english_name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="area_code"
              attribute="attributes.area"
              :label="$t('attributes.area')"
            >
              <b-select
                v-model="selectedArea"
                name="area_code"
                :loading="isLoading"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                expanded
                @input="onSelectArea"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.area') }}
                </option>
                <option
                  v-for="option in areas"
                  :key="option.code"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button :loading="isSending" @click="$parent.close()">
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button
            :loading="isSending || isLoading"
            type="is-primary"
            native-type="submit"
          >
            {{ $t('attributes.update') }}
          </b-button>
        </footer>

        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'CountryUpdateForm',

  props: {
    isSending: {
      type: Boolean,
      default: false
    },
    country: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      areas: [],
      selectedArea: null,

      form: {
        id: this.country.id,
        area_code: this.country.area_code && this.country.area_code.trim(),
        code: this.country.code && this.country.code.trim(),
        name: this.country.name && this.country.name.trim(),
        english_name:
          this.country.english_name && this.country.english_name.trim(),
        status: this.country.status
      }
    }
  },
  validations: {
    form: {
      area_code: { required },
      code: { required },
      name: { required },
      english_name: { required },
      status: { required }
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.isLoading = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)

        if (this.form.area_code) {
          this.selectedArea = this.areas.find(
            a => a.code === this.form.area_code
          )
        }
      } catch (e) {
        this.areas = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.isLoading = false
      }
    },
    onSelectArea(option) {
      this.form.area_code = option && option.code
    },
    send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
